import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import PageAccueil from './pages/PageAccueil';
import Informer from './pages/Informer';
import ListeStructures from './pages/ListeStructures';
import ListeDispositifs from './pages/ListeDispositifs';
import CarteMentaleCRT from './pages/CarteMentaleCRT';
import MorienterForm from './pages/MorienterForm';
import CarteMentaleEHPAD from './pages/CarteMentaleEHPAD';

// Récupère le basename injecté par WordPress via le shortcode ([carte_mentale])
const basename =
  document.getElementById('root')?.dataset?.basename?.replace(/\/+$/, '') || '/';

function Layout() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div>
      {/* Barre de navigation affichée uniquement si on n’est PAS sur la page d’accueil */}
      {!isHome && (
        <nav style={{ background: '#2563eb', padding: '10px' }}>
          <Link to="/minformer" style={{ color: 'white', marginRight: '20px' }}>M'informer</Link>
          <Link to="/morienter" style={{ color: 'white', marginRight: '20px' }}>M’orienter</Link>
          <Link to="/parcourstype" style={{ color: 'white' }}>Mon parcours type</Link>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<PageAccueil />} />
        <Route path="/minformer" element={<Informer />} />
        <Route path="/structures" element={<ListeStructures />} />
        <Route path="/dispositifs" element={<ListeDispositifs />} />
        <Route path="/dispositifs/crt" element={<CarteMentaleCRT />} />
        <Route path="/structures/ehpad" element={<CarteMentaleEHPAD />} />
        <Route path="/morienter" element={<MorienterForm />} />
        <Route path="/morienter/dispositifs/crt" element={<CarteMentaleCRT />} />
        {/* <Route path="/parcourstype" element={<ParcoursType />} /> (à venir) */}
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <Router basename={basename}>
      <Layout />
    </Router>
  );
}
